import { GroupItemBaseTriggerItemsQualifier } from "./group-item-base-trigger-items";
export class AllMatchGroupItemTriggerItemsQualifier extends GroupItemBaseTriggerItemsQualifier {
    _qualifyCouponItemsGroupQTY(group, coupon, cart, couponGroupItems) {
        const triggerItems = [];
        for (const cItem of couponGroupItems) {
            // keep taking full sets as long as possible
            while (true) {
                const set = [];
                for (let j = 0; j < cItem.quantity; j++) {
                    const tItem = this._qualifyCouponItemsGroup(group, coupon, cart, cItem);
                    if (!tItem)
                        break;
                    set.push(tItem);
                }
                if (set.length !== cItem.quantity)
                    break;
                triggerItems.push(...set);
            }
        }
        return triggerItems;
    }
}
//# sourceMappingURL=all-match-group-item-trigger-items.js.map